import React from 'react';
import StatusBanner from '../common/StatusBanner';
import * as Tools from "../../helpers/Tools";
import { logUI } from "../../api/andyliticsApi";

const successheading = "Thanks, you're all set!", errorInternalServerHeading = "We were unable to submit your answer.",
    errorConflictHeading = "Sorry, we're unable to continue.";

let topHeading = "", isError = false, subError = "";

export default class ProxyDeclineConfirmation extends React.Component {
    constructor(props) {
        super(props);        
    }

    componentDidMount() {        
        logUI("MBHWeb.UI.ProxyDeclineConfirmation.ComponentDidMount", new Date(), Tools.getURLPath());
    }   

    getErrorMessage(error) {
        const { declineRequest } = this.props;
        let errorMessage = "";
        logUI(`MBHWeb.${declineRequest ? declineRequest.proxySource:"Rx"}.ProxyDeclineConfirmation.GetErrorMessage`, new Date(), Tools.getURLPath(), JSON.stringify({ response: error }));
        if (error && (typeof error === "string" || typeof error === "number")) {
            switch (error) {
                case 409: //conflict
                case "Conflict":
                    errorMessage = errorConflictHeading;
                    break;
                case 500://internal server error
                case "Internal Server Error":
                    errorMessage = errorInternalServerHeading;
                    break;
                default:
                    errorMessage = errorInternalServerHeading;//as of now assigning same as internal server error.
            }
        }
        else if (error && error.message) {
            errorMessage = "You are not authorized to decline this request"; //this is not applicable but having it.
        } else if (error && typeof(error) === "object" && error.status && error.status === 400) { // Handling in case of error object as api response body is coming.
            errorMessage = errorInternalServerHeading;
        }
        else {
            errorMessage = error;
        }        
        return errorMessage;
    }

    render() {
        const { onDeclineRetry, success, error } = this.props;
        if (success) {
            topHeading = successheading;
            isError = false;
        }
        else if (error) {
            topHeading = this.getErrorMessage(error);
            if (topHeading === errorConflictHeading) {
                subError = "This request has already been processed.";
            }
            isError = true;
        }

        return (
            <div className="container-fluid body-content decline-confirmation-container">
                <div className="row">
                    <React.Fragment>
                        <div className="col-12">
                            <StatusBanner bannerMsg={topHeading} failedStatus={isError} subBannerMsg={subError}>
                                {subError === "" && (isError  ?
                                    <span>
                                        <span>To try again </span> <input type="submit" className="btn text-btn" value="click here." onClick={onDeclineRetry} />
                                    </span> :
                                    !isError && <span>We appreciate your feedback.</span>
                                )}
                            </StatusBanner>
                        </div>
                    </React.Fragment>
                </div>
            </div>);
    }
}

